import React from 'react'

const StaticPageNameContainer = ({ containerObject, templateName, contentId, dataZone }) => {
  return (
    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0`} >
    <div className='row mx-0 category-name-container px-0'>
					<h1 class="right-panel-heading" dangerouslySetInnerHTML={{ __html: containerObject && containerObject.staticPageTitle ? containerObject.staticPageTitle  : "" }}></h1>
				</div>
    </div>
  )
}

export default StaticPageNameContainer